var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with (null).")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-left",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0703125,3 C32.6015652,2.54687273 33.1601533,2.4648423 33.7460938,2.75390625 C34.3320342,3.0429702 34.625,3.52343414 34.625,4.1953125 L34.625,43.9453125 C34.625,44.6171909 34.3320342,45.0742175 33.7460938,45.3164062 C33.1601533,45.558595 32.6015652,45.4531273 32.0703125,45 L11.515625,26.25 C10.8437466,25.656247 10.5078125,24.9062545 10.5078125,24 C10.5078125,23.0937455 10.8437466,22.343753 11.515625,21.75 L32.0703125,3 Z",
    id: "directleft"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectLeft);
export default __webpack_public_path__ + "static/media/direct-left.7534ada6c4114c72e2547e04cb4eeb18.svg";
export { ForwardRef as ReactComponent };